import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IconMap2 } from '@tabler/icons-react';
import './FeatureShowcaseModal.css';

// Version this modal. When we want to re-trigger for a future feature drop,
// bump the suffix and write the new flag (e.g. featureShowcaseSeenV3) so old
// users see the new modal once without resetting the V2 flag.
const FeatureShowcaseModal = ({ open, onDismiss, onTryItNow }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!open) return null;

  const handleTryItNow = () => {
    onTryItNow?.();
    onDismiss?.();
    navigate('/create');
  };

  return (
    <div className="feature-showcase-overlay" onClick={onDismiss}>
      <div className="feature-showcase-modal" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="feature-showcase-close"
          onClick={onDismiss}
          aria-label={t('featureShowcase.close', 'Close')}
        >
          ×
        </button>
        <div className="feature-showcase-badge">{t('featureShowcase.badge', 'New')}</div>
        <h2 className="feature-showcase-title">
          {t('featureShowcase.title', 'Zwifters: virtual rides, real maps.')}
        </h2>
        <p className="feature-showcase-lead">
          {t('featureShowcase.lead', 'Say goodbye to random Solomon Islands rides.')}
        </p>
        <p className="feature-showcase-sublead">
          {t('featureShowcase.zwiftStatus', '2D Zwift maps are live now. 3D coming next.')}
        </p>

        <div className="feature-showcase-panels">
          <div className="feature-showcase-panel">
            <div className="feature-showcase-panel-icon">
              <IconMap2 size={22} />
            </div>
            <div className="feature-showcase-panel-text">
              <h3>{t('featureShowcase.zwiftTitle', 'Real Zwift world maps')}</h3>
              <p>{t('featureShowcase.zwiftDesc', 'Watopia, Makuri, France, Scotland and the rest as they truly are. No more water riding.')}</p>
            </div>
          </div>
        </div>

        <div className="feature-showcase-actions">
          <button
            type="button"
            className="feature-showcase-secondary"
            onClick={onDismiss}
          >
            {t('featureShowcase.later', 'Maybe later')}
          </button>
          <button
            type="button"
            className="feature-showcase-primary"
            onClick={handleTryItNow}
          >
            {t('featureShowcase.tryItNow', 'Try it now')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeatureShowcaseModal;
